import { colors } from 'src/templates/styles/colors';

export const FADE_OPACITY = 0.5;

export const GRID_SIZE = 150;
export const GRID_WIDTH = 5;
export const GRID_BACKGROUND_COLOR = '#f1f5f9'; // $vb-color-ui-gray-2-02
export const GRID_LINE_COLOR = '#e8eff5';

export const NODE_SIZE = 300;
export const NODE_RESOURCE_SIZE = 212;
export const NODE_TEXT_WIDTH_RATIO = 0.8;
export const NODE_FONT_SIZE = 40;
export const NODE_FONT_COLOR = colors.softBlack;
export const NODE_FONT_WEIGHT = 'bold';
export const NODE_FONT_FACE = 'avenir, sans-serif';
export const NODE_FULL_SIZE_SCALE = 1;
export const NODE_SMALL_SIZE_SCALE = 0.5;

export const MODEL_CONCEPT_DEFAULT_COLOR = 'white';
export const MODEL_CONCEPT_MAPPED_ICON_COLOR = colors.softBlack;
export const MODEL_CONCEPT_MAPPED_ICON_SIZE = 40;
export const MODEL_CONCEPT_STROKE_COLOR = colors.softBlack;
export const MODEL_CONCEPT_STROKE_WIDTH = 12;

/** width/height of square when minimized */
export const MODEL_CONCEPT_ATTRIBUTES_BADGE_SIZE = 75;
/** width of rectangle when expanded */
export const MODEL_CONCEPT_ATTRIBUTES_LIST_WIDTH = 240;
/** max amount of list items to show when expanded */
export const MODEL_CONCEPT_ATTRIBUTES_LIST_LIMIT = 5;

export const RESOURCE_COLOR = colors.softBlack;
export const RESOURCE_ICON_MASK_STROKE_WIDTH = 2;
export const RESOURCE_COMBINED_ICON_RATIO = 0.95;
export const RESOURCE_ICON_RATIO = 0.66;

export const FILE_UPLOAD_MASK_COLOR = GRID_BACKGROUND_COLOR;
export const FILE_UPLOAD_ICON_NODE_RATIO = 0.75; // with respect to NODE_SIZE
export const FILE_UPLOAD_ICON_WIDTH_RATIO = 0.75; // with respect to FILE_UPLOAD_ICON_NODE_RATIO
export const FILE_UPLOAD_ICON_HEIGHT_RATIO = 1;
export const FILE_UPLOAD_ICON_TEXT_WIDTH_RATIO = 2; // with respect to icon size

export const VIRTUAL_GRAPH_MASK_COLOR = 'white';
export const VIRTUAL_GRAPH_ICON_NODE_RATIO = 0.65; // with respect to NODE_SIZE
export const VIRTUAL_GRAPH_ICON_WIDTH_RATIO = 1; // with respect to VIRTUAL_GRAPH_ICON_NODE_RATIO
export const VIRTUAL_GRAPH_ICON_HEIGHT_RATIO = 1;
export const VIRTUAL_GRAPH_ICON_TEXT_WIDTH_RATIO = 1.5; // with respect to icon size

/** used in `strokeDashArray` for making dashes of X pixels */
export const MAPPING_DASH_SIZE = 45;
/** used in `strokeDashArray` for space between dashes */
export const MAPPING_DASH_SPACING = 40;
export const MAPPING_LINK_WIDTH = 10;
export const MAPPING_LINK_SELECTED_WIDTH = 16;

export const LINK_COLOR = colors.softBlack;
export const LINK_WIDTH = 6;
export const LINK_SELECTED_WIDTH = 12;
export const LINK_ARROW_SCALE = 4;
export const LINK_MIN_LENGTH = 300;

export const LINK_LABEL_BACKGROUND_COLOR = GRID_BACKGROUND_COLOR;
export const LINK_LABEL_MAX_SIZE = 500;
export const LINK_LABEL_PADDING = 2;
export const LINK_LABEL_FONT_FACE = 'avenir, sans-serif';
export const LINK_LABEL_FONT_SIZE = 42;
export const LINK_LABEL_FONT_WEIGHT = 'bold';

export const SELF_LINK_CURVINESS = 0.5;

export const RELINK_HALO_STROKE_WIDTH = 2;
export const RELINK_HALO_STROKE_COLOR = colors.lightBlue;

/**
 * width/height of the diamond grab handle
 *
 * This shows up when you hover over the unconnected end of a Mapping or ModelConceptRelationship.
 */
export const LINK_GRAB_HANDLE_SIZE = 40;
export const LINK_HANDLE_FILL_COLOR = colors.lightBlue;
export const LINK_HANDLE_STROKE_COLOR = colors.mediumBlue;

export const DELETED_OUTLINE_COLOR = colors.deletedOutline;
export const DELETED_BACKGROUND_COLOR = colors.deletedBackground;

export const DRAFT_OUTLINE_COLOR = colors.draftOutline;
export const DRAFT_BACKGROUND_COLOR = colors.draftBackground;
export const DRAFT_BACKGROUND_OUTLINE_WIDTH = 4;
